<template>
  <card class="parc-card">
    <!-- Map -->
    <template #image>
      <parc-map />
    </template>

    <div>
      <parc-actions
        :isPublishable="isPublishable"
      />

      <!-- MODALE PUBLICATION -->
      <publish-modal :activate-published-status="activatePublishedStatus" />


      <!-- MODALE DEPUBLICATION -->
      <unpublish-modal :desactivate-published-status="desactivatePublishedStatus" />

      <!-- Informations -->
      <parc-info/>

    </div>
    <div>
    </div>

    <!-- MODALE EXPLOITANT -->
    <edit-modal
      @reload-parc="$emit('reload-parc')"
      :lex-satut-saisie="lexSatutSaisie"
      :isPublishable="isPublishable"
      :addNotification="addNotification"
      :setSelectedSituation="setSelectedSituation"
    />

    <!-- MODALE VUE D'ENSEMBLE -->
    <parc-recap-modal />

    <!-- MODALE FORMULAIRE RENOUVELLEMENT -->
    <renouvellement-form-modal
      :putParc="putParc"
      :addNotification="addNotification"
    />

    <!-- MODALE LISTE RENOUVELLEMENT -->
    <renouvellement-list-modal />

  </card>
</template>
<script>
import {LIcon, LMap, LMarker, LPolygon, LTileLayer, LTooltip} from "@vue-leaflet/vue-leaflet";
import LIconPosteLivraison from "@/components/LIcons/LIconPosteLivraison.vue";
import ButtonClearDate from "@/components/Buttons/ButtonClearDate.vue";
import DataTables from "./ParcProfileParcCardDataTables.vue";
import RenouvellementList from "./ParcProfileParcCardRenouvellementList.vue";
import GunTable from "./ParcProfileParcCardGunTable.vue";

import {parcService} from "@/service/parc.service.js";
import {lexiqueService} from "@/service/lexique.service.js";
import {mapService} from "@/service/map.service.js";

import {mapGetters} from "vuex";
import ParcMap from "@/components/ParcCard/ParcMap.vue";
import ParcInfo from "@/components/ParcCard/ParcInfo.vue";
import {BModal} from "bootstrap-vue-next";
import ExploitantActions from "@/components/ParcCard/ParcActions/ExploitantActions.vue";
import ParcActions from "@/components/ParcCard/ParcActions/index.vue";
import ParcRecapModal from "@/components/Modals/ParcRecapModal.vue";
import EditModal from "@/components/Modals/EditModal.vue";
import RenouvellementListModal from "@/components/Modals/RenouvellementListModal.vue";
import RenouvellementFormModal from "@/components/Modals/RenouvellementFormModal.vue";
import PublishModal from "@/components/Modals/PublishModal.vue";
import UnpublishModal from "@/components/Modals/UnpublishModal.vue";

export default {
  components: {
    UnpublishModal,
    PublishModal,
    RenouvellementFormModal,
    RenouvellementListModal,
    EditModal,
    ParcRecapModal,
    ParcActions,
    ExploitantActions,
    BModal,
    ParcMap,
    ParcInfo,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LIcon,
    LTooltip,
    LIconPosteLivraison,
    Notification,
    DataTables,
    RenouvellementList,
    ButtonClearDate,
    GunTable
  },
  data() {
    return {
      //Formulaire pour découper le parc
      splitParc: {
        nouvelId: null,
        id: null,
        aerogenerateurIds: []
      },
      searchParcId: null,
      selectedParc: null,
      isParcSelected: false,
      communes: [],
      communeSearch: "",
      validNomCommune: null,
      lexSatutSaisie: [],
      selectedSituation: "",
      tempParc: {},
      validAerogenerateurSection: false,
      validPosteLivraisonSectionSection: false,
      emptyField: "Non renseigné",
      isRenouvellementSubmitDisabled: true,
    };
  },
  computed: {
    ...mapGetters({
      isExploitant: "isExploitant",
      isAdministrateur: "isAdministrateur",
      isDreal: "isDreal",
      isAdministrateurRegionParc: "isAdministrateurRegionParc",
      isBrouillon: "isBrouillon",
      isLock: "isLock",
      isPublie: "isPublie",
      isRejet: "isRejet",
      isRefus: "isRefus",
      isCessationActivite: "isCessationActivite",
      isEolienneDeclarationValid: "isEolienneDeclarationValid",
      isPosteLivraisonDeclarationValid: "isPosteLivraisonDeclarationValid",
      isInventaireCommunes: "isInventaireCommunes",
      isRenouvellement: "isRenouvellement",
      isRenouvellementNotable: "isRenouvellementNotable",
      isRenouvellementSubstantiel: "isRenouvellementSubstantiel",
      eoliennesConstructeurs: "eoliennesConstructeurs",
      eoliennesMaxHauteur: "eoliennesMaxHauteur",
      defaultMapZoom: "defaultMapZoom",
      selectedMapElement: "selectedMapElement",
      eoliennes: "eoliennes",
      droits: "droits",
      parc: "parc",
      parcs: "parcs",
      renouvellement: "renouvellement",
    }),
    //Filtre qui donne la liste des droits sans le droit sur le parc en cours
    droitsOption: function(){
      return this.droits.filter(droit => droit.etablissement ? droit.etablissement.indexOf(this.parc.id) : '')
    },
    // Autorise la publication si les données sont diffusables
    isPublishable() {
      return !(this.isRejet || this.isRefus || this.isCessationActivite);
    }
  },
  watch: {
    selectedMapElement() {
      this.toggleTooltip();
    },
    selectedParc() {
      if (this.selectedParc == '') {
        this.isParcSelected = false;
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      mapService.setDefaultIcons();
      this.tempParc = {...this.$store.getters.parc};
      this.parseParcDate();
      this.getLexStatutSaisie();

      //Initialisation du formulaire de split
      this.splitParc.id = this.parc.id;
      this.selectedParc = null;
      this.isParcSelected = false;
    },
    parseParcDate() {
      Object.keys(this.parc).forEach((field, index) => {
        let value = Object.values(this.parc)[index];
        // dateVerrou is not to be used in front. So no need to parse it.
        // furthermore, parsing it break PUT query .
        if (field.includes("date") && field !== 'dateVerrou') {
          if (value) {
            this.parc[field] = this.bootstrapDateFormat(value);
          }
        }
      });
    },
    bootstrapDateFormat(value) {
      const date = new Date(value);
      let month = date.getMonth() + 1;
      let day = date.getDate();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      return [date.getFullYear(), month, day].join("-");
    },
    putParc() {
      this.parc.dateDelivranceRefus = this.selectedSituation === "refus" ? this.parc.dateDelivranceRefus : null;
      this.setStatutSaisie();

      const parcId = this.parc.id;
      parcService
        .putParc(this.parc)
        .then(response => {
          parcService.getParcById(parcId).then(parcUpdated => {
            this.$store.dispatch("saveParc", parcUpdated);
          });
          this.addNotification(response);
        })
        .catch(err => {
          console.log(err);
        });
    },
    addNotification(response) {
      if (response) {
        // OK
        if (response.status == "200") {
          response.text().then(message => {
            const notificationTextMessage = message;
            const notificationIcon = "ti-check";
            const notificationType = "success";

            this.$store.dispatch("saveTextNotification", {
              notificationIcon,
              notificationType,
              notificationTextMessage
            });

            this.$emit("reload-parc");
          });
          // BAD REQUEST
        } else if (response.status == "400") {
          response.json().then(message => {
            const notificationJsonMessage = message;
            const notificationTitle =
              "Les modifications n'ont pas été prises en compte";
            const notificationIcon = "ti-alert";
            const notificationType = "danger";

            this.$store.dispatch("saveJsonNotification", {
              notificationTitle,
              notificationIcon,
              notificationType,
              notificationJsonMessage
            });
          });

          // Other HTTP response
        } else {
          let notificationIcon = "ti-alert pt-1";
          let notificationType = "danger";
          let notificationTextMessage = "Une erreur est survenue";

          // FORBIDDEN
          if (response.status == "403") {
            notificationIcon = "ti-lock pt-1";
            notificationTextMessage =
              "Vous avez tenté d'accéder à une ressource non autorisée";

            // INTERNAL ERROR
          } else if (response.status == "500") {
            notificationTextMessage = "Le serveur a rencontré une erreur";
          }

          this.$store.dispatch("saveTextNotification", {
            notificationIcon,
            notificationType,
            notificationTextMessage
          });

          throw Error(`Request rejected with status ${response.status}`);
        }
      } else {
        const notificationIcon = "ti-alert pt-1";
        const notificationType = "danger";
        const notificationTitle = "La connexion a été interrompue";
        const notificationJsonMessage = ["Veuillez réactualiser la page"];

        this.$store.dispatch("saveJsonNotification", {
          notificationTitle,
          notificationIcon,
          notificationType,
          notificationJsonMessage
        });
      }
    },
    getStatutSaisieById(id) {
      return this.lexSatutSaisie.find(s => s.id === id);
    },
    setStatutSaisie() {
      const statutBrouillon = this.getStatutSaisieById(1);
      const statutDepublie = this.getStatutSaisieById(3);

      // Si le parc est Refusé/Rejeté/En cessation d'activité, le statut devient "Dépublié"
      if (this.parc.dateDelivranceRejet != null || this.parc.dateDelivranceRefus != null || this.parc.dateCessationActivite != null) {
        this.parc.statutSaisie = statutDepublie;
      } else if (this.parc.statutSaisie == null || this.parc.statutSaisie?.id === 4) {
        // Si statut null ou "Saisie non démarrée", passer en "Brouillon"
        this.parc.statutSaisie = statutBrouillon;
      }
    },
    getLexStatutSaisie() {
      lexiqueService
        .getLexStatutSaisie()
        .then(data => {
          this.lexSatutSaisie = data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    activatePublishedStatus() {
      this.parc.statutSaisie = this.getStatutSaisieById(2); // Publié
      this.putParc();
    },
    desactivatePublishedStatus() {
      this.parc.statutSaisie = this.getStatutSaisieById(1); // Brouillon
      this.putParc();
    },
    toggleTooltip() {
      const tooltipElList = document.getElementsByClassName("leaflet-tooltip");
      if (this.selectedMapElement != "") {
        for (let i = 0; i < tooltipElList.length; i++) {
          if (
            tooltipElList[i].firstElementChild != null &&
            tooltipElList[i].firstElementChild.innerText ==
              this.selectedMapElement
          ) {
            tooltipElList[i].classList.add("map-card__show-tooltip");
          }
        }
      } else {
        for (let i = 0; i < tooltipElList.length; i++) {
          tooltipElList[i].classList.remove("map-card__show-tooltip");
        }
      }
    },
    formatDate(value) {
      const date = new Date(value);

      let month = date.getMonth() + 1;
      let day = date.getDate();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      return [day, month, date.getFullYear()].join("/");
    },
    setSelectedSituation(event) {
      this.selectedSituation = event.target.value;
    }
  }
};
</script>
<style lang="scss">
.parc-card {
  .map-card {
    position: relative;
    &__info-btn {
      position: absolute;
      top: 11px;
      right: 4px;
      z-index: 1000;
    }
    &__show-tooltip {
      opacity: 0.9 !important;
    }
  }

  .empty-field {
    color: grey;
  }

  .burger-btn {
    & > button {
      padding: 0 10px;
      border-radius: 0.25rem !important;
    }

    &__list {
      position: relative;

      button {
        z-index: 10 !important;
        text-transform: uppercase;
        font-size: 0.8em !important;
        font-weight: bold;
        &:hover {
          background-color: #41B883 !important;
        }

      }
    }
  }

  .parc-btn {
    .parc-icon {
      display: none;
    }

    @media screen and (min-width: 768px) and (max-width: 1202px) {
      .parc-icon {
        display: inline-block;
        width: 21px !important;
      }

      .parc-btn-label {
        display: none;
      }
    }

    @media screen and (max-width: 531px) {
      .parc-icon {
        display: inline-block;
        width: 21px !important;
      }

      .parc-btn-label {
        display: none;
      }
    }

    &--dreal {
      .parc-icon {
        display: none;
      }

      @media screen and (min-width: 768px) and (max-width: 812px) {
        .parc-icon {
          display: inline-block;
          width: 21px !important;
        }

        .parc-btn-label {
          display: none;
        }
      }

      @media screen and (max-width: 392px) {
        .parc-icon {
          display: inline-block;
          width: 21px !important;
        }

        .parc-btn-label {
          display: none;
        }
      }
    }
  }
}
.parc-form {
  .form-control {
    border: #ced4da 1px solid;
  }

  .communes-list, .parcs-list {
    position: relative;

    &__group {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      background: #ffffff;
      z-index: 10;
    }

    &__item {
      &:hover {
        cursor: pointer;
        background-color: #ececec;
      }
    }

    &__deleteBtn {
      border: none;
    }
  }

  .renouvellement-input {
    small {
      font-size: 0.7rem;
    }
    & > *:hover {
      cursor: pointer;
    }
  }

  .contentieux-input {
    small {
      font-size: 0.7rem;
    }
    & > *:hover {
      cursor: pointer;
    }
  }

  .btn-clear-input {
    position: absolute;
    top: 28px;
    right: 20px;
  }
}

</style>
